console.warn(`构建时间: ${__BUILD_TIME__}`)
import('@/main')
